/*
********************************************************************************
PAGE FLOW MAPPING — single source of truth for page flow structure.

PAGES      = the catalog: every page defined ONCE. The MAP KEY (e.g. "page1")
             is the page's id — it is NOT repeated inside the value. Each value
             carries route / component / label only. `route` and `component`
             are verified against index.html's <ion-route> registrations.
PAGE_FLOWS = each vendor+direction flow as an ORDERED LIST OF PAGE KEYS.

PageFlowManager resolves a flow by mapping keys to entries and stamping the id
back on: PAGE_FLOWS[key].map(id => ({ pageId: id, ...PAGES[id] })). So resolved
entries expose `.pageId`, but the id lives in exactly one place here (the key) —
the key and id can never drift.

Adding a new vendor flow that reuses existing pages = add ONE line to PAGE_FLOWS.
Adding a brand-new page = add one PAGES entry here (keyed by its pageId) + one
validators entry in validation.js (keyed by the same pageId) + the usual
new-page wiring.

This module imports nothing from the app and reads no runtime state, so it is
safe to evaluate at import time.

See docs/page-flow-refactoring-plan.md and memory project_page_flow_refactor.
********************************************************************************
*/

export const PAGES = {
	page1: { route: "/inspection-details", component: "inspection-details", label: "Inspection Details" },
	page2: { route: "/exterior-inspection", component: "exterior-inspection", label: "Exterior Inspection" },
	page3: { route: "/glovebox-check", component: "glovebox-check", label: "Glovebox Documents" },
	page4: { route: "/interior-check", component: "interior-check", label: "Interior Check" },
	page5: { route: "/road-test", component: "road-test", label: "Road Test" },
	page6: { route: "/lights-check", component: "lights-check", label: "Lights Check" },
	page7: { route: "/fluid-inspection", component: "fluid-inspection", label: "Fluid Inspection" },
	page8: { route: "/tire-inspection", component: "tire-inspection", label: "Tire Inspection" },
	page9: { route: "/inspection-photos", component: "inspection-photos", label: "Inspection Photos" },
	page10: { route: "/signature", component: "app-signature", label: "Signature and Release" },
	page11: { route: "/mercedes-interior-check", component: "interior-inspection", label: "Interior Inspection" },
	page12: { route: "/mercedes-road-test", component: "mercedes-road-test", label: "Road Test" },
	page13: { route: "/mercedes-communication-check", component: "mercedes-communication-check", label: "Communication Check" },
	page14: { route: "/mercedes-function-check", component: "mercedes-function-check", label: "Function Check" },
	page15: { route: "/mercedes-out-vehicle-settings", component: "mercedes-out-vehicle-settings", label: "Vehicle Settings" },
	page16: { route: "/mercedes-out-display-settings", component: "mercedes-out-display", label: "Central Display Settings" },
	page17: { route: "/mercedes-out-upon-delivery", component: "mercedes-out-upon-delivery", label: "Upon Delivery" },
};

// Key format: `${vendor}-${direction}` — vendor is "Mercedes-Benz" or "default",
// direction is lowercase "return"/"delivery". PageFlowManager normalizes inputs
// to build this key. Order = the exact navigation order for that flow.
export const PAGE_FLOWS = {
	"default-return": ["page1", "page3", "page8", "page9", "page2", "page11", "page4", "page5", "page6", "page7", "page10"],
	"default-delivery": ["page1", "page3", "page8", "page2", "page11", "page4", "page5", "page6", "page7", "page9", "page10"],
	"Mercedes-Benz-return": ["page1", "page3", "page8", "page9", "page2", "page11", "page12", "page14", "page13", "page10"],
	"Mercedes-Benz-delivery": ["page1", "page3", "page8", "page2", "page11", "page15", "page16", "page17", "page9", "page10"],
};
